export class Grant {
  constructor(){}

  user_name: string;
  user_email: string;
  organization_name: string;
  status_name: string;
  id: string;
  applicantkey: string;
  user_id: string;
  organization_id: string;
  createdate: string;
  updatedate: string;
  updateuser_id: string;
  status_id: string;
  agency_name: string;
  agency_street: string;
  agency_city: string;
  agency_state: string;
  agency_zipcode: string;
  agency_phone: string;
  county: string;
  zipcode: string;
  ryan_white_certified: string;
  gender: string;
  assigned_gender: string;
  american_indian: string;
  african_american: string;
  pacific_islander: string;
  asain: string;
  white: string;
  asian_indian: string;
  chinese: string;
  filipino: string;
  japanese: string;
  korean: string;
  vietnamese: string;
  other_asian: string;
  native_hawaiian: string;
  guamanian_chamorro: string;
  samoan: string;
  other_pacific_islander: string;
  hispanic: string;
  mexican: string;
  puerto_rican: string;
  cuban: string;
  other_hispanic: string;
  msm: string;
  idu: string;
  hetero: string;
  hemophilia_disorder: string;
  perinatal: string;
  blood_transfusion: string;
  not_reported: string;
  medical_insurance: string;
  living_arrangement: string;
  how_long_years: string;
  how_long_months: string;
  housing_subsidy: string;
  housing_subsidy_source: string;
  low_income_housing: string;
  low_income_housing_source: string;
  family_size: string;
  annual_family_income: string;
  narrative: string;
  payment_delivery: string;
  request_type: string;
  housing_request: string;
  utilities_request: string;
  medical_services_request: string;
  housing_equipment_request: string;
  medical_equipment_request: string;
  transportation_non_medical_request: string;
  health_insurance_premiums_request: string;
  legal_fees_request: string;
  personal_care_request: string;
  services_request: string;
  other_request: string;
  vendor_company: string;
  vendor_contact?: string;
  vendor_street: string;
  vendor_city: string;
  vendor_state: string;
  vendor_zipcode: string;
  vendor_phone: string;
  vendor_fax: string;
  account_number: string;
  amount_requested_total: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/grant.ts